import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../utils/api';
import Footer from '../components/Footer';

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const nav = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [policy, setPolicy] = useState(null);

  // The server is the authority on the rules; show the same text it enforces.
  useEffect(() => {
    api.get('/auth/password-policy').then(r => setPolicy(r.data)).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    const min = policy?.min_length || 8;
    if (password.length < min) return setError(`Password must be at least ${min} characters.`);
    if (password !== confirm) return setError('Passwords do not match.');
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'This reset link is invalid or has expired.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <h1>Toledo Ticket OMS</h1>
          <p>Reset Password</p>
          <div className="gold-bar" />
        </div>

        {!token ? (
          <p className="form-hint" style={{ textAlign: 'center' }}>
            This link is missing its token. Please use the link from your reset email.
          </p>
        ) : done ? (
          <>
            <p className="form-hint" style={{ textAlign: 'center' }}>
              Your password has been reset. You can now sign in.
            </p>
            <button className="btn btn-primary btn-lg" style={{ width: '100%', marginTop: 12 }} onClick={() => nav('/login')}>
              Go to sign in
            </button>
          </>
        ) : (
          <form onSubmit={submit}>
            {error && <div className="alert alert-error" style={{ marginBottom: 12 }}>{error}</div>}
            <div className="form-group">
              <label className="form-label">New password</label>
              <input type="password" className="form-input" required value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder={`At least ${policy?.min_length || 8} characters`} />
              {policy?.description && <p className="form-hint">{policy.description}</p>}
            </div>
            <div className="form-group">
              <label className="form-label">Confirm new password</label>
              <input type="password" className="form-input" required value={confirm}
                onChange={e => setConfirm(e.target.value)} />
            </div>
            <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={loading}>
              {loading ? 'Saving…' : 'Set new password'}
            </button>
          </form>
        )}
      </div>
      <div className="login-footer"><Footer /></div>
    </div>
  );
}
